import { gql } from '@src/lib/gql'

export const CLARITY_ADVISOR_IMPORT = gql`
  query ClarityAdvisorImport($handle: String!) {
    clarityAdvisorImport(handle: $handle) {
      handle
      canonicalScreenName
      claimStatus
      expert {
        expertId
        fullName
        firstName
        lastName
        screenName
        bio
        location
        imageUrl
        hourlyRate
        clarityProfileUrl
        shortBio
      }
    }
  }
`
